export default {
  name: "IntroductionDetailItem",
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};